export const getAbuseColor = (abuseName: string): string => {
  // Remove any description after the dash for matching
  const baseName = abuseName.split(' - ')[0].trim();
  
  const colorMap: Record<string, string> = {
    // Primary abuse types with unique, distinct colors from the design system
    'Incorrect Driving Initiation': 'bg-violet-500',
    'Incorrect Driving Initiation - Starting vehicle improperly': 'bg-violet-500',
    
    'Truck Loading Abuse': 'bg-emerald-500', 
    'Truck Loading Abuse - Improper Loading Technique': 'bg-emerald-500',
    'Truck loading Abuse': 'bg-emerald-500', // handle lowercase variant
    
    'Hot Engine Shut Off': 'bg-sky-500',
    'Hot Engine Shut Off Without Cooldown Period': 'bg-sky-500',
    
    'Hydraulic Brake Usage': 'bg-rose-500',
    'Hydraulic Brake Usage While Moving at High Speed': 'bg-rose-500',
    
    'Wrong Gear During Loading': 'bg-orange-500',
    'Wrong Gear During Loading Operations': 'bg-orange-500',
    
    'Wheel Digging': 'bg-amber-500',
    'Wheel Digging and Excessive Tire Spin': 'bg-amber-500',
    
    'Service Brake Applied with Hoist Raised': 'bg-indigo-500',
    'Service Brake Applied with Hoist Raised Position': 'bg-indigo-500',
    
    'Hoist Lever Position Abuse': 'bg-pink-500',
    'Hot Lever Position Abuse': 'bg-teal-500',
    'Hot Lever Position Abuse During Operation': 'bg-teal-500',
    
    'Improper Load Balancing': 'bg-yellow-500',
    
    // Additional abuse types with extended color palette
    'Engine Overspeed': 'bg-red-500',
    'Excessive Idling': 'bg-lime-500',
    'Harsh Acceleration': 'bg-cyan-500',
    'Harsh Braking': 'bg-purple-500',
    'Excessive Speed': 'bg-fuchsia-500',
    'Overloading': 'bg-blue-500',
    'Tire Pressure Abuse': 'bg-green-500',
    'Clutch Riding': 'bg-slate-500',
    'Gear Grinding': 'bg-zinc-500',
    'Cold Start Abuse': 'bg-stone-500'
  };
  
  // Try exact match first
  if (colorMap[abuseName]) return colorMap[abuseName];
  if (colorMap[baseName]) return colorMap[baseName];
  
  // Try partial matches for common patterns with distinct colors
  if (baseName.toLowerCase().includes('incorrect driving')) return 'bg-violet-500';
  if (baseName.toLowerCase().includes('truck') && baseName.toLowerCase().includes('loading')) return 'bg-emerald-500';
  if (baseName.toLowerCase().includes('hot engine')) return 'bg-sky-500';
  if (baseName.toLowerCase().includes('hydraulic brake')) return 'bg-rose-500';
  if (baseName.toLowerCase().includes('wrong gear')) return 'bg-orange-500';
  if (baseName.toLowerCase().includes('wheel digging')) return 'bg-amber-500';
  if (baseName.toLowerCase().includes('service brake')) return 'bg-indigo-500';
  if (baseName.toLowerCase().includes('hoist lever')) return 'bg-pink-500';
  if (baseName.toLowerCase().includes('hot lever')) return 'bg-teal-500';
  if (baseName.toLowerCase().includes('engine') && baseName.toLowerCase().includes('speed')) return 'bg-red-500';
  if (baseName.toLowerCase().includes('idling')) return 'bg-lime-500';
  if (baseName.toLowerCase().includes('acceleration')) return 'bg-cyan-500';
  if (baseName.toLowerCase().includes('harsh') && baseName.toLowerCase().includes('brak')) return 'bg-purple-500';
  if (baseName.toLowerCase().includes('speed')) return 'bg-fuchsia-500';
  if (baseName.toLowerCase().includes('overload')) return 'bg-blue-500';
  if (baseName.toLowerCase().includes('tire')) return 'bg-green-500';
  if (baseName.toLowerCase().includes('clutch')) return 'bg-slate-500';
  if (baseName.toLowerCase().includes('gear') && baseName.toLowerCase().includes('grind')) return 'bg-zinc-500';
  if (baseName.toLowerCase().includes('cold start')) return 'bg-stone-500';
  
  // Fallback colors for unmatched patterns
  const fallbackColors = [
    'bg-indigo-400', 'bg-blue-400', 'bg-teal-400', 'bg-cyan-400',
    'bg-green-400', 'bg-lime-400', 'bg-yellow-400', 'bg-amber-400',
    'bg-orange-400', 'bg-red-400', 'bg-pink-400', 'bg-purple-400',
    'bg-violet-400', 'bg-fuchsia-400', 'bg-rose-400', 'bg-sky-400'
  ];
  
  // Generate a consistent color based on the string hash
  const hash = baseName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return fallbackColors[hash % fallbackColors.length];
};

export const getAbuseTextColor = (abuseName: string): string => {
  const colorMap: Record<string, string> = {
    'Incorrect Driving Initiation': 'text-red-500',
    'Truck loading Abuse': 'text-orange-500',
    'Hot Engine Shut Off': 'text-yellow-500',
    'Hydraulic Brake Usage': 'text-blue-500',
    'Wrong Gear During Loading': 'text-purple-500',
    'Wheel Digging': 'text-green-500',
    'Improper Load Balancing': 'text-pink-500',
    'Service Brake Applied with Hoist Raised': 'text-indigo-500',
    'Hoist Lever Position Abuse': 'text-teal-500'
  };
  
  return colorMap[abuseName] || 'text-gray-500';
};